function initSidebarFilter(prefix = 'page') {
    const containerSelector = prefix === 'header' ? '.search-box, .filter-section, .filter-apply-btn' : '.search-box.sidebar-filter-section, .filter-section.sidebar-filter-section, .filter-apply-btn.sidebar-filter-section';
    const searchInput = document.querySelector(`#${prefix}-search-input`);
    const searchButton = document.querySelector(`#${prefix}-search-addon`);
    const filterApplyButton = document.querySelector(`.${prefix} .filter-apply-btn a.btn-main`);
    const container = document.querySelector(`.${prefix}`) || document;

    // State management for filters
    let sidebarFilters = {
        material: [],
        shape: [],
        back: [],
        type: [],
        surface: [],
        excludeCollection: ["sample-products"],
        title: ''
    };

    function toggleFilter(filterId) {
        const filterContent = document.getElementById(`${filterId}-filter`);
        if (!filterContent) return;
        const filterHeader = filterContent.previousElementSibling;
        filterHeader.classList.toggle('active');
    }

    // Size buttons (surface filter)
    const sizeButtons = container.querySelectorAll('.size-btn');
    sizeButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            if (this.classList.contains('active')) {
                // If already active, remove active and clear surface filter
                this.classList.remove('active');
                sidebarFilters.surface = [];
            } else {
                // Remove active from all buttons and add to clicked button
                sizeButtons.forEach(b => b.classList.remove('active'));
                this.classList.add('active');
                sidebarFilters.surface = [this.getAttribute('data-value')];
            }
        });
    });

    // Checkbox handling
    const checkboxes = container.querySelectorAll('.filter-content input[type="checkbox"]');
    checkboxes.forEach(input => {
        input.addEventListener('change', function() {
            const checkboxVisual = this.parentNode.querySelector('.checkbox');
            const filterName = this.name;
            const value = this.value;

            if (this.checked) {
                checkboxVisual.classList.add('checked');
                if (!sidebarFilters[filterName].includes(value)) {
                    sidebarFilters[filterName].push(value);
                }
            } else {
                checkboxVisual.classList.remove('checked');
                sidebarFilters[filterName] = sidebarFilters[filterName].filter(v => v !== value);
            }
        });
    });

    function handleSearch() {
        sidebarFilters.title = searchInput.value.trim();
        searchInput.value = sidebarFilters.title;
        
        resetAllFiltersExceptSearch();

        redirectToProductsPage();
    }

    if (searchButton) {
        searchButton.addEventListener('click', handleSearch);
    }

    if (searchInput) {
        searchInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                handleSearch();
            }
        });
    }

    if (filterApplyButton) {
        filterApplyButton.addEventListener('click', function(e) {
            e.preventDefault();

            resetSearchInput();

            redirectToProductsPage();
        });
    }

    // Function to redirect to products page with query params
    function redirectToProductsPage() {
        const params = new URLSearchParams();

        Object.keys(sidebarFilters).forEach(filterKey => {
            if (filterKey === 'title') {
                if (sidebarFilters[filterKey] && sidebarFilters[filterKey].trim()) {
                    params.set('title', sidebarFilters[filterKey].trim());
                }
            } else {
                if (sidebarFilters[filterKey] && sidebarFilters[filterKey].length > 0) {
                    params.set(filterKey, sidebarFilters[filterKey].join(','));
                }
            }
        });

        const productsUrl = `/products${params.toString() ? '?' + params.toString() : ''}`;
        window.location.href = productsUrl;
    }

    function resetAllFiltersExceptSearch() {
        sidebarFilters.material = [];
        sidebarFilters.shape = [];
        sidebarFilters.back = [];
        sidebarFilters.type = [];
        sidebarFilters.surface = [];
        sidebarFilters.excludeCollection = ["sample-products"];

        container.querySelectorAll('.filter-content input[type="checkbox"]').forEach(input => {
            input.checked = false;
            const checkboxVisual = input.parentNode.querySelector('.checkbox');
            checkboxVisual.classList.remove('checked');
        });

        container.querySelectorAll('.size-btn').forEach(btn => {
            btn.classList.remove('active');
        });
    }

    function resetSearchInput() {
        sidebarFilters.title = '';

        if (searchInput) {
            searchInput.value = '';
        }
    }

    function resetAllFilters() {
        resetAllFiltersExceptSearch();
        resetSearchInput();
    }

    window.resetFilters = function() {
        resetAllFilters();
        redirectToProductsPage();
    };

    function initializeSidebarFromURL() {
        const urlParams = new URLSearchParams(window.location.search);

        ['material', 'shape', 'back', 'type', 'surface', 'excludeCollection'].forEach(filterKey => {
            const paramValue = urlParams.get(filterKey);
            if (paramValue) {
                sidebarFilters[filterKey] = paramValue.split(',').filter(v => v.trim());
            }
        });

        const title = urlParams.get('title');
        if (title) {
            sidebarFilters.title = title;
        }

        syncSidebarUIWithState();
    }

    function syncSidebarUIWithState() {
        container.querySelectorAll('.filter-content input[type="checkbox"]').forEach(input => {
            const filterName = input.name;
            const value = input.value;
            const shouldBeChecked = sidebarFilters[filterName] && sidebarFilters[filterName].includes(value);

            input.checked = shouldBeChecked;
            const checkboxVisual = input.parentNode.querySelector('.checkbox');
            if (shouldBeChecked) {
                checkboxVisual.classList.add('checked');
            } else {
                checkboxVisual.classList.remove('checked');
            }
        });

        container.querySelectorAll('.size-btn').forEach(btn => {
            const value = btn.getAttribute('data-value');
            const shouldBeActive = sidebarFilters.surface && sidebarFilters.surface.includes(value);

            if (shouldBeActive) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });

        if (searchInput && sidebarFilters.title) {
            searchInput.value = sidebarFilters.title;
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        if (typeof collectionHandle !== 'undefined') {
            initializeSidebarFromURL();
        }
    });

    window.toggleFilter = toggleFilter;
}

document.addEventListener('DOMContentLoaded', function() {
    const isProductsPage = window.location.pathname === '/products' ||
        window.location.pathname.startsWith('/products?') ||
        window.location.pathname === '/collections' ||
        window.location.pathname.startsWith('/collections?');

    initSidebarFilter('header');

    if (!isProductsPage) {
        initSidebarFilter('page');
    }
});